import { render, staticRenderFns } from "./WebdevClicker.vue?vue&type=template&id=2023db4d&scoped=true&"
import script from "./WebdevClicker.vue?vue&type=script&lang=js&"
export * from "./WebdevClicker.vue?vue&type=script&lang=js&"
import style0 from "./WebdevClicker.vue?vue&type=style&index=0&id=2023db4d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023db4d",
  null
  
)

export default component.exports